import { createContext, useCallback, useContext, useMemo } from 'react'
import * as React from 'react'

import ModalContext from 'contexts/ModalContext'
import DocumentsModal from 'tripPlanner/components/TripModal/Documents/DocumentsModal'
import type { TripDocumentsResult } from 'tripPlanner/hooks/api/documents'
import {
  useTripDocuments,
} from 'tripPlanner/hooks/api/documents'
import type { FullTrip } from 'tripPlanner/types/common'

export interface TripDocumentsContextValue {
  documentsResult: TripDocumentsResult | undefined
  onRequestAddDocument: (tripId?: string) => void
}

export const TripDocumentsContext = createContext<
  TripDocumentsContextValue | undefined
>(undefined)

interface Props {
  children: React.ReactNode
  trip: FullTrip
}

export function TripDocumentsContextProvider({ children, trip }: Props) {
  const { data: documentsResult } = useTripDocuments({ tripId: trip.id })

  const openModal = useContext(ModalContext)

  const onRequestAddDocument = useCallback(
    (tripItemId?: string) => {
      openModal(<DocumentsModal trip={trip} tripItemId={tripItemId} />)
    },
    [openModal, trip],
  )

  const value = useMemo<TripDocumentsContextValue>(
    () => ({ documentsResult, onRequestAddDocument }),
    [documentsResult, onRequestAddDocument],
  )

  return (
    <TripDocumentsContext.Provider
      value={value}
    >
      {children}
    </TripDocumentsContext.Provider>
  )
}
